<div class="checkout-plan-picker tw-pt-8">
  <form
    (ngSubmit)="updatePlan()"
    id="form.changePlanForm"
    role="form"
    name="form.changePlanForm"
    novalidate
  >
    <select-plan
      [(isUnlimitedPlan)]="isUnlimitedPlan"
      [(periodMonthly)]="periodMonthly"
      [displayCount]="displayCount"
      [planType]="planType"
      [subscriptionId]="subscriptionId"
      (selectedProductCodeChange)="updateProductCode($event)"
    >
    </select-plan>

    <div class="button-toolbar flex-row w-100 w-lg-75 mx-0 mx-lg-auto mb-5">
      <a
        matButton="outlined"
        id="cancelButton"
        actionLink
        (click)="cancel()"
        class="tw-flex-1"
        >Cancel</a
      >
      <button
        type="submit"
        id="subscribeButton"
        class="btn btn-primary tw-flex-1 mt-0"
      >
        Next
      </button>
    </div>
  </form>
</div>
